import {useMutation} from "@tanstack/react-query";
import * as api from "../../api";

export const useUsersExportMutation = () => {
    return useMutation({
        mutationFn: async (data) => await api.User.exportUsers(data),
        onSuccess: (data) => {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(new Blob([data.data]));
            link.download = data.fileName; // specify the filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    });
}